import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getPointsGraph = createAsyncThunk(
  "AgentPoints/getPointsGraph",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/users/points/stats/${data.user_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return {...resp.data};
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

